function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import Tooltip from "./Tooltip";

var HotspotSwitch = function (_React$Component) {
  _inherits(HotspotSwitch, _React$Component);

  function HotspotSwitch() {
    _classCallCheck(this, HotspotSwitch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  HotspotSwitch.prototype.render = function render() {
    var _props = this.props,
        isActive = _props.isActive,
        toggle = _props.toggle;
    return React.createElement("div", {
      className: "recorder__toolbar-option recorder__toolbar-option--hotspot " + (isActive ? "is-active" : null)
    }, React.createElement("div", {
      className: "recorder__toolbar-option-label"
    }, "placement grid"), React.createElement("button", {
      onClick: toggle,
      className: "toggle toggle--color-bunker toggle--size-m " + (isActive ? "is-active" : null)
    }), React.createElement(Tooltip, {
      isActive: isActive
    }));
  };

  return HotspotSwitch;
}(React.Component);

HotspotSwitch.propTypes = process.env.NODE_ENV !== "production" ? {
  isActive: PropTypes.bool,
  toggle: PropTypes.func.isRequired
} : {};
export default HotspotSwitch;